<template>
	<div class="cooperation">
		<div class="top">
			<span>零成本加盟智慧校园</span>
			<span>双方共享校园资源，包括硬件、软件整合，共享品牌、客户、渠道、产品等运营，实现合作共赢。</span>
		</div>
		<h3>知会云校园</h3>
		<div class="short_stub" style="margin-bottom: 0rem;">
			<div></div>
			<div></div>
		</div>
		<div class="hezuo_c" style="height: height: 1.96875rem;;">
			<img src="../assets/corp/img1.png" style="width: 2.916666rem;"/>
			<div class="hezuo_right_container" style="display: flex;flex-direction: column;justify-content: space-around;height: 1.96875rem;">
				<div class="hezuo_right_wrapper" style="">
					<span style="">互联网+AI+教育</span>
					<span style="">以“互联网+AI+教育”为基础，联接刷脸门禁、考勤机、访客机、刷脸支付、智能宿舍、电子班牌、智慧教室等多场景设备，</span>
				</div>
				<div class="hezuo_right_wrapper" style="margin-top: -0.15625rem;">
					<span>一脸通模式</span>
					<span>以全新的“一脸通模式”打破校园信息孤岛，给学校、家长、老师、学生提供全方位的校园信息化服务。</span>
				</div>
			</div>
		</div>
		<h3>项目优势</h3>
		<div class="short_stub">
			<div></div>
			<div></div>
		</div>
		<div class="youshi_c">
			<div class="youshi_i">
				<img src="../assets/corp/11.png" />
				<span >政策利好</span>
				<span >教育部发布《教育信息化2.0》，全面启动K12智慧校园信息化升级</span>
			</div>
			<div class="youshi_i">
				<img src="../assets/corp/12.png" />
				<span>市场空间大</span>
				<span>K12学校约51.8万所，近2.5亿学生，潜在市场规模近万亿</span>
			</div>
			<div class="youshi_i">
				<img src="../assets/corp/13.png" />
				<span>客户群体稳</span>
				<span>每年有新生注入，二胎政策开放，客户群体在稳步增长</span>
			</div>
			<div class="youshi_i">
				<img src="../assets/corp/14.png" />
				<span>收益模式多</span>
				<span>服务费、项目建设费、增值服务费、银行补贴等模式可灵活选择</span>
			</div>
		</div>
		<div class="youshi_c">
			<div class="youshi_i">
				<img src="../assets/corp/15.png" />
				<span >技术壁垒强</span>
				<span >知会云依托十余年的AIoT、SaaS技术积累和行业经验沉淀</span>
			</div>
			<div class="youshi_i">
				<img src="../assets/corp/16.png" />
				<span>超高回报率</span>
				<span>资金投入少，服务好1万学生轻松实现年入百万</span>
			</div>
			<div class="youshi_i">
				<img src="../assets/corp/17.png" />
				<span>事业周期长</span>
				<span>一次投入，长期回报，深度绑定校园信息化服务</span>
			</div>
			<div class="youshi_i">
				<img src="../assets/corp/18.png" />
				<span>投资风险小</span>
				<span>不管处在什么时代社会都会持续支持教育事业</span>
			</div>
		</div>
		
		
		<h3>服务支持</h3>
		<div class="short_stub">
			<div></div>
			<div></div>
		</div>
		<div class="youshi_c">
			<img src="../assets/corp/img2.png" style="width: 4.713541rem;height: 3.671875rem;" />
		</div>
		
		<h3>合作加盟</h3>
		<div class="short_stub">
			<div></div>
			<div></div>
		</div>
		<div class="corp_container">
			<div class="corp_factor">
				<span>无论你是</span>
				<span><img src="../assets/corp/icon.png"/> 未来有意向投身教育领域的创业者或者实干家</span>
				<span><img src="../assets/corp/icon.png"/> 充满热情的教育领域或者教育服务行业的从业者</span>
				<span><img src="../assets/corp/icon.png"/> 拥有校园资源，期望快速变现的行业人士</span>
			</div>
			<div class="corp_factor" style="margin-left: 0.520833rem;">
				<span>对你的基本要求</span>
				<span style="margin-top: 0.104166rem;"><img src="../assets/corp/icon.png"/> 诚实守信，严格履行合约</span>
				<span><img src="../assets/corp/icon.png"/> 有较强的沟通能力，积极拓展市场</span>
				<span><img src="../assets/corp/icon.png"/> 有一定的幼儿园、中小学校园资源</span>
				<span><img src="../assets/corp/icon.png"/> 了解基础教育行业，愿意投身其中</span>
			</div>
		</div>
		
		
		
		<h3>合作加盟</h3>
		<div class="short_stub">
			<div></div>
			<div></div>
		</div>
		<div class="corp_process_container">
			<span>“ 全程无需任何加盟代理费 ”</span>
			<div class="corp_process_factor" style="margin-top: 0.416666rem;">
				<img src="../assets/corp/img3.png"/>
			</div>
		</div>
		
		<div class="zixun_c">
			<span class="zixun_c_title">欢迎咨询合作</span>
			<span>
				如有疑问或合作意向，请留下您的姓名和联系电话，我们将尽快联系您
				<br />您也可直接致电免费热线：400-138-9808
			</span>
			<form action>
				<div class="form_t">
					<div class="form_t_i">
						<span>姓名</span>
						<input type="text" v-model="formMess.name" />
					</div>
					<div class="form_t_i">
						<span>手机（必填）</span>
						<input type="phone" maxlength="11" v-model="formMess.phone" />
					</div>
					<div class="form_t_i">
						<span>邮箱</span>
						<input type="email" v-model="formMess.email" />
					</div>
				</div>
				<div class="form_problem">
					<span>问题描述</span>
					<textarea type="text" v-model="formMess.problem" />
				</div>
			</form>
			<button class="btn_submit" @click="submit">提交</button>
		</div>
  </div>
</template>
<style  scoped>
	.corp_process_container span {
		height: 0.286458rem;
		font-size: 0.208333rem;
		font-family: AlibabaPuHuiTiB;
		color: #000000;
		line-height: .286458rem;
	}
	
	.corp_process_container img {
		width: 6.25rem;
		height: 0.729166rem;
	}
	.corp_process_container {
		margin-bottom: 1.041666rem;
	}
	
.corp_container {
	display: flex;flex-direction: row;
}
.corp_factor {
	display: flex;flex-direction: column;align-items: flex-start;
	width: 1.875rem;
	height: 2.03125rem;
	background: #F6F6F6;
	border-radius: 0.208333rem;justify-content: space-around;
	padding: 0.416666rem 0.260416rem 0.416666rem 0.3125rem;
}

.corp_factor :nth-child(1) {
	font-size: 0.208333rem;
	font-family: AlibabaPuHuiTiB;
	color: #2F6EF0;
	line-height: 0.286458rem;
}

.corp_factor :nth-child(2),.corp_factor :nth-child(3),.corp_factor :nth-child(4),.corp_factor :nth-child(5) {
	height: 64px;
	font-size: 0.104166rem;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #404040;
	line-height: 0.166666rem;
	text-align: left;
}

.cooperation {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.top {
  width: 100%;
  height: 2.604167rem;
  background: url(../assets/corp/banner.jpg) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.top span:nth-child(1) {
  font-size: .3125rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: .3125rem;
}
.top span:nth-child(2) {
  font-size: .15625rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.75);
  line-height: .15625rem;
  margin-top: 0.15625rem;
}
.hezuo_c {
  display: flex;
  align-items: center;
}

.hezuo_right_wrapper {
	display: flex;flex-direction: column;justify-content: space-around;align-items: flex-start;
}
.hezuo_right_wrapper span:nth-child(1){
	font-size: 0.125rem;width: 2.604166rem;text-align: left;
}
.hezuo_right_wrapper span:nth-child(2){
	font-size: 0.083333rem;width: 2.604166rem;text-align: left;
}

.youshi_c {
	display: flex;flex-direction: row;
}

.youshi_i {
  height: 1.755208rem;
  width: 1.380208rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 0.119791rem;
  margin-top: 0.208333rem;
  border-radius: 0.052083rem;
  border: 1px solid #2F6EF0;;
}
.youshi_i img {
  width: 0.3125rem;
  height: 0.3125rem;
  margin-bottom: 0.135417rem;
}
.youshi_i span:nth-child(2) {
  font-size: 0.104167rem;
  font-weight: 600;
  color: rgba(47, 110, 240, 1);
  line-height: 0.104167rem;
  margin-bottom: 0.135417rem;
}
.youshi_i span:nth-child(3) {
  font-size: 0.083333rem;
  font-weight: 400;
  color: rgba(76, 76, 76, 1);
  line-height: 0.125rem;
  margin: 0 0.208333rem;
  text-align: center;
}
.zixun_c {
  width: 100%;
  height: 4.010417rem;
  background: url(//static.h5.ylmob.com/website/img/shangwu_bottom.png)
    no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #FFFFFF;
}
.zixun_c_title {
  font-size: 0.208333rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 0.3125rem;
  margin-top: 0.416667rem;
}
.zixun_c_d {
  font-size: 0.083333rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.125rem;
  margin-top: 0.104167rem;
}
.form_t {
  width: 5.208333rem;
  justify-content: space-between;
  display: flex;
  align-items: center;
  margin-top: 0.3125rem;
}
.form_t_i {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.form_t_i span {
  font-size: 0.083333rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 0.083333rem;
  margin-bottom: 0.083333rem;
}
.form_t_i input {
  outline-style: none;
  width: 1.666667rem;
  height: 0.3125rem;
  border: 1px solid rgba(255, 255, 255, 0.8);
  background-color: transparent;
  padding: 0.0625rem;
  box-sizing: border-box;
  font-size: 0.083333rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  caret-color: rgba(255, 255, 255, 1);
}
.form_problem {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 0.208333rem;
}
.form_problem span {
  font-size: 0.083333rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 0.083333rem;
  margin-bottom: 0.083333rem;
}
.form_problem textarea {
  outline-style: none;
  width: 5.208333rem;
  height: 0.78125rem;
  border: 1px solid rgba(255, 255, 255, 0.8);
  background-color: transparent;
  padding: 0.0625rem;
  box-sizing: border-box;
  font-size: 0.083333rem;
  line-height: 0.125rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  caret-color: rgba(255, 255, 255, 1);
}
.btn_submit {
  width: 1.041667rem;
  height: 0.3125rem;
  border: 0px;
  outline: none;
  background: rgba(63, 110, 240, 1);
  border-radius: 0.229167rem;
  margin-top: 0.416667rem;
  color: rgba(255, 255, 255, 1);
  font-size: 0.104167rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
}
.btn_submit:hover {
  background: rgb(42, 93, 231);
}
</style>

<script>
import http from '../utils/http.js';
export default {
  components: {},
  data() {
    return {
      formMess: {
        name: "",
        phone: "",
        email: "",
        problem: ""
      },
      checkdata: [
        {
          inspect: "", // 待检测的字段
          msg: "姓名" // 空值返回的提示
        },
        {
          inspect: "",
          msg: "手机号",
          reg: "^[1][3,4,5,7,8][0-9]{9}$"
        },
        {
          inspect: "",
          msg: "邮箱",
          reg:
            "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
        },
        {
          inspect: "",
          msg: "问题描述"
        }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 判定是否合规
    have_empty(arr) {
      for (let key in arr) {
        if (arr[key].inspect && arr[key].reg) {
          // 有值并且有规则执行验证
          let reg = new RegExp(arr[key].reg);
          var red_end = reg.test(arr[key].inspect);
          if (!red_end) {
            this.$alert("请输入正确的" + arr[key].msg, "提示", {
              confirmButtonText: "确定",
              // center: true
            });
            console.log("请输入正确的" + arr[key].msg);
            return false;
          }
        } else if (!arr[key].inspect) {
           this.$alert("请输入" + arr[key].msg, "提示", {
              confirmButtonText: "确定",
              // center: true
            });
          console.log("请输入" + arr[key].msg);
          return false;
        }
      }
      return true;
    },

    assignData() {
      //赋值
      var arrForm = [];
      for (let key in this.formMess) {
        arrForm.push(key);
      }
      for (let i = 0; i < this.checkdata.length; i++) {
        var key = arrForm[i];
        this.checkdata[i].inspect = this.formMess[key];
      }
      return arrForm;
    },

    submit() {
        this.assignData();
        var end = this.have_empty(this.checkdata);
        if (!end) return; // 判定验证结果
        http.syncTime(this.formMess).then(res => {
        console.log(res);
        this.$alert("提交成功", "提示", {
            confirmButtonText: "确定",
        });
        }).catch(error => {
            // 权限访问异常
            console.log(error);
        });
    }
  },
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
};
</script>
